import React from "react";
import { useNavigate } from "react-router-dom";

import {
  Layout,
  Form,
  Input,
  Button,
  Select,
  Card,
  Row,
  Col,
  Breadcrumb,
  Space,
  // DatePicker,
} from "antd";

// import { convertToSlug, getBaseUrl } from '../../utils/browser'
import { nationalityOptions } from "../../data/countries";
import { useBackend } from "backend/useBackend";

const { Content } = Layout;

const endpoint = "authors";

const Add = () => {
  const navigate = useNavigate();
  const { addItem } = useBackend();

  const [form] = Form.useForm();

  const manageFullName = (e) => {
    const el = e.target;
    if (el.id === "firstName") {
      form.setFieldValue("fullName", el.value + " " + form.getFieldValue('lastName'));
    }
    if (el.id === "lastName") {
      form.setFieldValue("fullName", form.getFieldValue('firstName') + " " + el.value);
    }
    // if (el.id === "fullName") {
    //   form.setFieldValue("fullName", el.value);
    // }
  };

  const onFinish = (values) => {
    const payload = {
      ...values,
      // dob: values?.dob && values.dob.toISOString(),
      // died: values?.died && values.died.toISOString(),
    };
    // console.log(payload)
    addItem(endpoint, payload, {
      redirectTo: endpoint,
      loader: true,
      msg: {
        loading: "Adding...",
        success: "Author Added",
      },
    });
  };

  const onFinishFailed = (data) => console.log(data);

  return (
    <Content>
      <Breadcrumb>
        <Breadcrumb.Item>Authors</Breadcrumb.Item>
        <Breadcrumb.Item>Add</Breadcrumb.Item>
      </Breadcrumb>
      <Row>
        <Col md={12}>
          <Card title="Add Details">
            <Form
              form={form}
              size="large"
              layout="vertical"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
            >
              <Row gutter={24}>
                <Col md={12}>
                  <Form.Item
                    className="mb-2"
                    label="First Name"
                    name="firstName"
                    rules={[
                      { required: true, message: "First Name is required" },
                    ]}
                  >
                    <Input placeholder="First Name" onChange={manageFullName} />
                  </Form.Item>
                </Col>
                <Col md={12}>
                  <Form.Item
                    className="mb-2"
                    label="Last Name"
                    name="lastName"
                    rules={[
                      { required: true, message: "Last Name is required" },
                    ]}
                  >
                    <Input placeholder="Last Name" onChange={manageFullName} />
                  </Form.Item>
                </Col>
                <Col md={24}>
                  <Form.Item
                    className="mb-2"
                    label="Full Name"
                    name="fullName"
                    rules={[
                      { required: true, message: "Full Name is required" },
                    ]}
                  >
                    <Input
                      placeholder="Full Name"
                      // onChange={manageFullName}
                      // value={fullName || firstName + " " + lastName}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={24}>
                <Col md={12}>
                  <Form.Item
                    className="mb-2"
                    label="Date of Birth"
                    name="dob"
                    // rules={[{ required: true, message: "Dob is required" }]}
                  >
                    <Input placeholder="YYYY-MM-DD" />
                    {/* <DatePicker
                      format={"DD-MM-YYYY"}
                      style={{ width: "100%" }}
                      // onChange={e => setDob(e.toISOString())}
                    /> */}
                  </Form.Item>
                </Col>
                <Col md={12}>
                  <Form.Item
                    className="mb-2"
                    label="Died"
                    name="died"
                    // rules={[{ required: true, message: "Died is required" }]}
                  >
                    <Input placeholder="YYYY-MM-DD" />
                    {/* <DatePicker
                      format={"DD-MM-YYYY"}
                      style={{ width: "100%" }}
                      // onChange={e => setDied(e.toISOString())}
                    /> */}
                  </Form.Item>
                </Col>
              </Row>
              <Form.Item
                className="mb-2"
                label="Occupation"
                name="occupation"
                rules={[{ required: true, message: "Occupation is required" }]}
              >
                <Input placeholder="Occupation" />
              </Form.Item>
              <Form.Item
                className="mb-2"
                label="About"
                name="about"
                // rules={[{ required: true, message: "About is required" }]}
              >
                <Input.TextArea placeholder="About" />
              </Form.Item>
              <Form.Item
                className="mb-2"
                // required
                label="Nationality"
                name="nationality"
                rules={[{ required: true, message: "Nationality is required" }]}
              >
                <Select
                  showSearch
                  placeholder="Select Nationality"
                  optionFilterProp="children"
                  // onChange={onChange}
                  // onSearch={onSearch}
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  options={nationalityOptions()}
                />
              </Form.Item>
              <Form.Item>
                <Row justify="end" style={{ marginTop: "2em" }}>
                  <Col>
                    <Space size="small">
                      <Button type="primary" htmlType="submit" size="large">
                        Add
                      </Button>
                      <Button
                        type="primary"
                        ghost
                        size="large"
                        onClick={() => navigate(-1)}
                      >
                        Back
                      </Button>
                    </Space>
                  </Col>
                </Row>
              </Form.Item>
            </Form>
          </Card>
        </Col>
      </Row>
    </Content>
  );
};

export default Add;
